import { render, staticRenderFns } from "./Sending.vue?vue&type=template&id=6785a9a4"
import script from "./Sending.vue?vue&type=script&lang=js"
export * from "./Sending.vue?vue&type=script&lang=js"
import style0 from "./Sending.vue?vue&type=style&index=0&id=6785a9a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports